import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=318dc3be&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=318dc3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318dc3be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318dc3be')) {
      api.createRecord('318dc3be', component.options)
    } else {
      api.reload('318dc3be', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=318dc3be&scoped=true&", function () {
      api.rerender('318dc3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/comp/DocBox.vue"
export default component.exports